import { useEffect, useState } from "react";

function useCountDownTimer({
  setDisableResendCode,
  disableResendCode,
  start = true,
}) {
  const [date, setDate] = useState("");

  useEffect(() => {
    if (!start) return;
    if (!disableResendCode) return;

    var duration = 60 * 20;
    var timer = duration,
      minutes,
      seconds;
    var timerID = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var finalDate = minutes + ":" + seconds;
      setDate(finalDate);

      if (--timer < 0) {
        clearInterval(timerID);
        setDisableResendCode(false);
        return;
      }
    }, 1000);

    return function cleanup() {
      clearInterval(timerID);
    };

    //eslint-disable-next-line
  }, [disableResendCode, start]);

  return { date };
}

export default useCountDownTimer;
